import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import {useAppState, useAuthService, useDataClientService} from "@stores/AppStateContext";

import {TaskDeleteProps} from "../modal-names";


import {DeleteWithConfirmation} from "../components/DeleteWithConfirmation/DeleteWithConfirmation";
import {deleteTask} from "../../../../actions/taskList/deleteTask";
import {hasReports as hasReportsRequest} from "../../../../stores/taskLists/requests/hasReports";


export const TaskDelete = observer(({
    task,
    taskListModel,
    taskListUnitModel,
}: TaskDeleteProps) => {
    const appState = useAppState();
    const authService = useAuthService();
    const dataClients = useDataClientService();

    const [hasReports, setHasReports] = useState(false);

    useEffect(() => {
        (async () => {
            setHasReports(await hasReportsRequest(dataClients, authService, task.id));
        })();
    }, [task.id]);

    return (
        <DeleteWithConfirmation
            header={intl.get('TaskDelete.header').d('Delete Task')}
            confirmText={intl.get('TaskDelete.Confirm.button').d('Delete Task')}
            text={intl.getHTML('TaskDelete.text', {taskName: task.name}).d(`You’re about to permanently delete the task <strong>{taskName}</strong>, along with all related data. This action <strong>cannot be undone.</strong>`)}
            onConfirm={async () => {
                await deleteTask(dataClients, authService, task, taskListUnitModel, taskListModel);
                appState.setModal(null);
            }}
            onClose={() => appState.setModal(null)}
            showConfirmation={hasReports}
            conditions={[
                intl.get('TaskListDelete.first-field.text').d('All completion history and reports will be deleted'),
                intl.get('TaskListDelete.second-field.text').d('Attached photos and other confirmations cannot be recovered'),
            ]}
        />
    );
});
